export const makeDecodeURL = (url, isTitle = false) => {
    const safeUrl = url.replace(/%(?![0-9A-Fa-f]{2})/g, '%25');

    let decodeName = '';
    for (const item of decodeURIComponent(safeUrl)) {
        if (item === ' ' && !isTitle) {
            decodeName += '%20';
        } else {
            decodeName += item;
        }
    }

    return decodeName;
};
